import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as enums from '../enums'

export const DOC = gql`
  fragment FragmentOrganization on SpaceOrganization {
    id
    code
    description
    entityId
    name
    parentId
    jointUseInfo {
      calculationMode
      manualFunctionalizations {
        functionId
        percent
      }
    }
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentOrganizationFragment,
  ents.extra.space.Organization
>({
  code: transformers.PASS_THROUGH,
  description: transformers.PASS_THROUGH,
  entityId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Entity.Id.isId,
  ),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.Organization.Id.isId,
  ),
  jointUseInfo: graphql.transformers.OUT.nullable(
    graphql.transformers.OUT.object({
      calculationMode: graphql.transformers.OUT.nonNull(
        enums.calculationMode.TRANSFORMER,
      ),
      manualFunctionalizations: graphql.transformers.OUT.nullable(
        graphql.transformers.OUT.list(
          graphql.transformers.OUT.object({
            functionId: graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              ents.extra.space.Function.Id.assertIsId,
              { warnOnly: true },
            ),
            percent: transformers.PASS_THROUGH,
          }),
          { onNullish: 'remove' },
        ),
      ),
    }),
  ),
  name: transformers.PASS_THROUGH,
  parentId: graphql.transformers.OUT.nullable(
    graphql.transformers.OUT.validate(
      transformers.PASS_THROUGH,
      ents.extra.space.Organization.Id.isId,
    ),
  ),
})
